import { parseTime } from '../util/datemath'

export enum Timezone {
  Default = '',
  Browser = 'browser',
  UTC = 'utc'
}

class VisualizerService {

  parseTimepickerTimeToVisualizerTime(time: string, roundUp: boolean, timezone: Timezone) {
    return new Date(parseTime(time, roundUp, timezone)).getTime() + 'ms'
  }

  isEncoded(component: string) {
    let result = component.substring(0, component.length)
    result = result || '';

    return result !== decodeURIComponent(result);
  }

  fullyDecodeURI(component: string) {
    let result = component.substring(0, component.length)
    while (this.isEncoded(result)){
      result = decodeURIComponent(result);
    }

    return result;
  }

}

export default new VisualizerService()
